import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import Input from '../../Components/ComponentInput';
import isEmailAddressValid from '../../Utils/IsEmailAddressValid';
import Button from '@frontend-components/components/Button';
const AuthenticationLoginFormReset = ({ reset, errors = {}, prefilledEmail = '', onBack, isLoading = false }) => {
    const [email, setEmail] = useState(prefilledEmail);
    const [validationErrors, setValidationErrors] = useState(errors);
    useEffect(() => {
        setValidationErrors(errors);
    }, [errors]);
    const handleSubmitForm = (event) => {
        event.preventDefault();
        const newErrors = {};
        if (!isEmailAddressValid(email)) {
            newErrors.email = T('authentication.authenticate.errors.email');
        }
        setValidationErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            reset(email);
        }
    };
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmitForm }, { children: [_jsx("p", Object.assign({ className: 'tailwind-reset bg-white text-dark-teal text-sm mb-6' }, { children: T('authentication.authenticate.forgot_text') })), _jsx("div", Object.assign({ className: `${validationErrors.email ? '-mt-6' : ''} mb-6 input-wrap` }, { children: _jsx(Input, { id: 'login-name', placeholder: T('authentication.authenticate.email'), onChange: (value) => setEmail(value), value: email, error: validationErrors.email, classes: 'tailwind-reset focus:bg-white focus:outline-none focus:border-3 focus:border-lightest-teal focus:placeholder-transparent bg-lightest-teal font-normal text-dark-teal w-full h-11 pl-2 rounded-xs' }) })), _jsxs("div", Object.assign({ className: 'flex flex-col justify-center items-center' }, { children: [_jsx(Button, Object.assign({ id: 'login-submit', type: "submit", size: "fluid", isLoading: isLoading }, { children: T('authentication.authenticate.reset') })), _jsx("div", Object.assign({ className: 'input-wrap mb-3' }, { children: _jsx("button", Object.assign({ type: "button", className: 'tailwind-reset text-dark-teal font-medium text-xs mt-4', onClick: onBack }, { children: T('authentication.authenticate.back') })) }))] }))] })));
};
AuthenticationLoginFormReset.propTypes = {
    reset: PropTypes.func.isRequired,
    errors: PropTypes.shape(),
    prefilledEmail: PropTypes.string,
    onBack: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};
export default AuthenticationLoginFormReset;
